import CreateDocPopup from "./CreateDocPopup";

export default CreateDocPopup;



// WEBPACK FOOTER //
// ./src/components/CreateDocPopup/index.js